import { AfterViewInit, Type, Component, OnDestroy, ComponentRef, ChangeDetectorRef, inject, viewChild } from '@angular/core';
import { Subject } from 'rxjs';
import {InsertionDirective} from './insertion.directive';
import { ModalRef } from './modal-ref';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    imports: [InsertionDirective]
})
export class ModalComponent implements AfterViewInit, OnDestroy {
  private cd = inject(ChangeDetectorRef);


  modalHeader;
  componentRef: ComponentRef<any>;
  childComponentType: Type<any>;

  readonly insertionPoint = viewChild(InsertionDirective);

  private readonly _onClose = new Subject<void>();
  public onClose = this._onClose.asObservable();

  ngAfterViewInit() {
      this.loadChildComponent(this.childComponentType);
      this.cd.detectChanges();
  }
  ngOnDestroy() {
    if (this.componentRef) {
        this.componentRef.destroy();
    }
  }

  close(){
      this._onClose.next();
  }

  loadChildComponent(componentType: Type<any>) {
      const viewContainerRef = this.insertionPoint().viewContainerRef;
      viewContainerRef.clear();

      this.componentRef = viewContainerRef.createComponent(componentType);
  }
  onOverlayClicked(evt: MouseEvent) {

  }

  onModalClicked(evt: MouseEvent) {
    evt.stopPropagation();
  }

}
